export default "__VITE_ASSET__baf6f5c9__"